module.exports = __webpack_public_path__ + "img/joy.2232ef4b.jpeg";